<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CwZyEz/tc-custom/9781453277249.jpg?1706964428834" alt="This image is the cover for the book Spiced to Death, The Gourmet Detective Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spiced to Death, The Gourmet Detective Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>“This appealing detective serves up nuggets of culinary trivia and wry food humor” (<i>People</i>).</b><br/>   In the days of Marco Polo, men risked their lives for spices. And in an age when black pepper was so valuable that it was sold one peppercorn at a time, there was no spice more valuable than the legendary Ko Feng. Known as the Celestial Spice, it supposedly vanished five centuries ago, and its name lives on only as culinary myth. But now a sack of it has turned up in New York City, and the leading experts of world cuisine will kill for a taste. When London’s finest gourmet detective proclaims the mysterious spice authentic, this sack of weeds becomes the most valuable substance on earth, worth thousands of dollars per gram. But soon the spice vanishes, one of his colleagues is murdered, and the detective is forced to dive into New York’s culinary underworld. His palate may be refined, but this gourmet knows how to fight dirty.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter King
      </h2>
      
      <p class="authorDescription body article">Peter King (b. 1922) is an English author of mystery fiction, a Cordon Bleu&ndash;trained chef, and a retired metallurgist. He has operated a tungsten mine, overseen the establishment of South America&rsquo;s first steel processing plant, and prospected for minerals around the globe. His work carried him from continent to continent before he finally settled in Florida, where he led the design team for the rocket engines that carried the Apollo astronauts to the moon.&#160;In his spare time, King wrote one-act plays and short mystery stories. When he retired, in 1991, he wrote his first novel, <i>The Gourmet Detective</i>, a cozy mystery about a chef turned sleuth who solves mysteries in the kitchen. King followed it with seven more books starring the character, including <i>Dying on the Vine </i>(1998) and <i>Roux the Day</i> (2002). In 2001 he published <i>Jewel of the North</i>, the first of three historical mysteries starring Jack London. King lives in Sarasota, Florida.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59022a80